// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MenuUnfoldOutlinedSvg from "@ant-design/icons-svg/es/asn/MenuUnfoldOutlined";
import AntdIcon from '../components/AntdIcon';

var MenuUnfoldOutlined = function MenuUnfoldOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MenuUnfoldOutlinedSvg
  }));
};

MenuUnfoldOutlined.displayName = 'MenuUnfoldOutlined';
export default React.forwardRef(MenuUnfoldOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MenuUnfoldOutlined.js
// module id = 1477
// module chunks = 0